import { getColumnWidth as getColumnWidthPersonalised } from '@nile/components';
import { KB_CONSTANTS } from '../../constants/kb-constants';
import { apiResolver, AccountClient, TicketClient } from '@nile/graphql';
import { GET_TECHNICIANS_BY_CRITERIA } from '@nile/graphql';

const DEFAULT_FILTER_CONDITION = {
  joinOperator: 'AND',
  operands: [
    {
      joinOperator: 'AND',
      operands: [
        {
          attribute: 'itemType',
          operator: 'is',
          value: KB_CONSTANTS.KB_ARTICLE
        }
      ]
    }
  ]
};

const getEntityAttributeName = (f = {}) => {
  switch (f.id) {
    case 'createdBy':
      return 'createdBy.name';
    default:
      return f.id;
  }
};
const checkCustomAttribute = (attr, field) => {
  switch (field?.id) {
    default:
      if (field?.id === attr) {
        return true;
      }
      return false;
  }
};

const checkDynamicQuery = (f) => {
  switch (f.id) {
    case 'createdBy':
    case 'kbArticle.createdBy.name':
      return true;
    default:
      return false;
  }
};

const getDynamicQuery = (f) => {
  const resolverModule = 'Ticket';
  let client = TicketClient;
  let query = apiResolver[resolverModule][f.name]?.api;

  switch (f.name) {
    case 'createdBy':
    case 'kbArticle.createdBy.name':
      client = AccountClient;
      query = GET_TECHNICIANS_BY_CRITERIA;
      return client.query({
        query: query,
        variables: {
          input: {
            listInfo: {
              sort: {
                attribute: 'name',
                order: 'ASC'
              }
            }
          }
        }
      });
    default:
      query = apiResolver[resolverModule][f.name]?.api;
      client = apiResolver[resolverModule][f.name]?.client;
      return client.query({
        query: query
      });
  }
};

const generateOptions = (f, data) => {
  let allValues = [];
  switch (f.name) {
    case 'createdBy':
    case 'kbArticle.createdBy.name':
      allValues = data.getTechnicianList.userList.map((el) => {
        return {
          ...el,
          name: el.name,
          value: el.name,
          label: el.name
        };
      });
      break;
    default:
      if (f.isCustom) {
        allValues = data.getCustomFieldByName.options.map((el) => {
          return {
            name: el,
            value: el,
            label: el
          };
        });
        return allValues;
      } else {
        allValues = [];
      }
  }
  return allValues;
};

const getAccessor = (col) => {
  switch (col.name) {
    case 'kbArticle.createdBy.name':
      return 'kbArticle.createdBy';
    default:
      return col.name;
  }
};

const getWidthPersonalization = (baseObj, name) => {
  switch (name) {
    case 'delete':
      return 50;
    default:
      return getColumnWidthPersonalised(baseObj, name);
  }
};

const getColumnCellType = (col) => {
  switch (col.id) {
    case 'name':
    case 'kbArticle.name':
      return 'COLLECTION';
    case 'lastModifiedOn':
      return 'DATE';
    case 'createdBy':
    case 'kbArticle.createdBy.name':
      return 'AVATAR';
    case 'delete':
      return 'DELETE';
    case 'feedback':
      return 'FEEDBACK';
    default:
      return 'TEXT';
  }
};

const getVariables = (property) => {
  switch (property.name) {
    default:
      return null;
  }
};

export {
  getAccessor,
  checkDynamicQuery,
  getVariables,
  getWidthPersonalization,
  getColumnCellType,
  DEFAULT_FILTER_CONDITION,
  getEntityAttributeName,
  generateOptions,
  getDynamicQuery,
  checkCustomAttribute
};
